import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Container,
  Divider,
  Grid,
  Header,
  Menu,
  Segment
} from 'semantic-ui-react';
import { dbUTCTimeToLocal2 } from '../../utils';
import { chartBlues } from '../../utils/chart';
// import { DateOptionsCostSpend, CostSpendOptions } from "../constants";

export const WeatherChart = ({ weather, location, ...props }) => {
  const weatherTime = t => dbUTCTimeToLocal2(t);

  const [activeItem, setActiveItem] = useState('Day');
  const [filteredWeather, setFilteredWeather] = useState([]);
  const [barWidth, setBarWidth] = useState(14);

  // const heavyRainProb = filteredWeather.map(w => w.heavy_rain_prob);
  // const heavySnowProb = filteredWeather.map(w => w.heavy_snow_prob);
  const rainProb = filteredWeather.map(w =>
    w.rain_prob > w.snow_prob ? w.rain_prob - w.snow_prob : 0
  );
  // const snowProb = filteredWeather.map(w => w.snow_prob);
  const snowProb = filteredWeather.map((w, i) => {
    return w.snow_prob;
  });
  const sfericProb = filteredWeather.map(w => w.sferics_prob);

  const xLabels = filteredWeather.map(w => weatherTime(w.timestamp));

  useEffect(() => {
    if (activeItem === 'Day') {
      setFilteredWeather(weather.slice(0, 8));
      setBarWidth(30);
    } else if (activeItem === 'Week') {
      setFilteredWeather(weather);
      setBarWidth(12);
    }
  }, [activeItem, weather]);

  // precipitation_prob
  // hail_prob
  // temp_max_screen_air
  // temp_min_screen_air
  // temp_feels_like
  // screen_relative_humidity

  // visibility

  const barData = {
    labels: xLabels,
    datasets: [
      {
        type: 'line',
        label: 'Lightning',
        borderColor: '#13C7FF',
        borderWidth: 2,
        borderJoinStyle: 'miter',
        lineTension: 0,
        pointBackgroundColor: '#FFFFFF',
        pointRadius: 3,
        fill: false,
        data: sfericProb
      },
      // {
      //   type: 'bar',
      //   label: 'Heavy Snow',
      //   backgroundColor: chartBlues[0],
      //   borderColor: chartBlues[0],
      //   borderWidth: 0,
      //   barThickness: barWidth,
      //   data: heavySnowProb,
      //   stack: 1, // Overlap bars
      //   scales: {
      //     yAxes: [
      //       {
      //         stacked: true
      //       }
      //     ]
      //   }
      // },
      {
        type: 'bar',
        label: 'Snow',
        backgroundColor: '#FFFFFF',
        borderColor: '#FFFFFF',
        borderWidth: 0,
        barThickness: barWidth,
        data: snowProb,
        stack: 1, // Overlap bars
        scales: {
          yAxes: [
            {
              stacked: true
            }
          ]
        }
      },
      // {
      //   type: 'bar',
      //   label: 'Heavy Rain',
      //   backgroundColor: chartArmyGreen[0],
      //   borderColor: chartArmyGreen[0],
      //   borderWidth: 0,
      //   barThickness: barWidth,
      //   data: heavyRainProb,
      //   stack: 1, // Overlap bars
      //   scales: {
      //     yAxes: [
      //       {
      //         stacked: true
      //       }
      //     ]
      //   }
      // },
      {
        type: 'bar',
        label: 'Rain',
        backgroundColor: chartBlues[1],
        borderColor: chartBlues[1],
        borderWidth: 0,
        barThickness: barWidth,
        data: rainProb,
        stack: 1, // Overlap bars
        scales: {
          yAxes: [
            {
              stacked: true
            }
          ]
        }
      }
    ]
  };

  return (
    <Segment {...props}>
      <div className="cost-spend-chart-segment-chart-wrapper">
        <Grid stackable stretched>
          <Grid.Row style={{ paddingTop: '0', paddingBottom: '0' }}>
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={11}
              textAlign="center"
              style={{ paddingRight: '0' }}
            >
              <div className="costspendToggles">
                <Menu
                  compact
                  size="small"
                  style={{
                    marginTop: '10px',
                    left: '40px'
                  }}
                >
                  <Menu.Item
                    active={activeItem === 'Day'}
                    name={'24 Hours'}
                    onClick={() => {
                      setActiveItem('Day');
                    }}
                  />
                  <Menu.Item
                    active={activeItem === 'Week'}
                    name={'7 Day'}
                    onClick={() => {
                      setActiveItem('Week');
                    }}
                  />
                </Menu>
                <Divider hidden />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: '0' }}>
            <Grid.Column
              width={16}
              textAlign="center"
              style={{ paddingRight: '0' }}
            >
              <Container style={{ marginLeft: '4%', paddingBottom: '10px' }}>
                <Header
                  as="h4"
                  color="grey"
                  size="medium"
                  style={{ marginTop: '0px', marginBottom: '0' }}
                >
                  Weather Forecast - {location}
                </Header>
                <Bar
                  type="bar"
                  id="weather-chart"
                  data={barData}
                  style={{ backgroundColor: 'rgba(198,241,255,255)' }}
                  options={{
                    plugins: {
                      legend: {
                        display: true,
                        position: 'bottom',
                        align: 'end',
                        labels: {
                          boxWidth: 12,
                          boxHeight: 10,
                          filter: item => item.text !== 'Forecast'
                        }
                      },
                      tooltips: {
                        callbacks: {
                          label: (
                            { datasetIndex, index },
                            { datasets, labels }
                          ) => {
                            const dataset = datasets[datasetIndex];
                            const label = labels[index];

                            return label === 'HIDDEN'
                              ? null
                              : `${label}: $${dataset.data[index]}k`;
                          }
                        }
                      },
                      datalabels: {
                        display: false
                      }
                    },
                    borderJoinStyle: 'miter',
                    scales: {
                      x: {
                        title: {
                          display: true,
                          text: 'Time'
                        },
                        grid: {
                          display: true
                        }
                      },
                      y: {
                        title: {
                          display: true,
                          text: 'Probability (%)'
                        },
                        ticks: {
                          callback: value => `${value}`
                        },
                        grid: {
                          display: true
                        }
                      }
                    }
                  }}
                  key={new Date().getTime()}
                  height={50}
                  width={100}
                />
              </Container>
            </Grid.Column>
            <Grid.Column computer={1} />
            {/*
            <Grid.Column
              floated="right"
              textAlign="center"
              mobile={16}
              tablet={16}
              computer={4}
              style={{
                margin: '0 auto',
                paddingLeft: '5%',
                paddingRight: '2%'
              }}
            >
              <div
                style={{
                  position: 'relative',
                  top: '4em'
                }}
              >
                <div style={{ position: 'relative', zIndex: 10 }}>
                  <Doughnut
                    type="doughnut"
                    id="total-cost-doughtnut"
                    data={{
                      datasets: [
                        {
                          data: [47, 71.35, 98, 41.8, 113],
                          backgroundColor: [
                            chartArmyGreen[0],
                            chartArmyGreen[1],
                            chartArmyGreen[2],
                            chartArmyGreen[3],
                            '#efefef'
                          ],
                          label: 'Dataset 1'
                        }
                      ],
                      labels: [
                        'Checks',
                        'Cost Management',
                        'Preferred Panel Spend',
                        'Non-Preferred Panel Spend',
                        'Remaining Budget'
                      ]
                    }}
                    options={{
                      plugins: {
                        datalabels: {
                          display: false
                        },
                        tooltips: {
                          enabled: false,

                          custom: tooltipModel => {
                            // Tooltip Element
                            let tooltipEl = document.getElementById(
                              'chartjs-tooltip'
                            );

                            // Create element on first render
                            if (!tooltipEl) {
                              tooltipEl = document.createElement('div');
                              tooltipEl.id = 'chartjs-tooltip';
                              tooltipEl.innerHTML = '<table></table>';
                              document.body.appendChild(tooltipEl);
                            }

                            // Hide if no tooltip
                            if (tooltipModel.opacity === 0) {
                              tooltipEl.style.opacity = 0;
                              return;
                            }

                            // Set caret Position
                            tooltipEl.classList.add('custom-tooltip');
                            tooltipEl.classList.remove(
                              'above',
                              'below',
                              'no-transform'
                            );
                            if (tooltipModel.yAlign) {
                              tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                              tooltipEl.classList.add('no-transform');
                            }

                            // Set Text
                            const getBody = bodyItem => bodyItem.lines;

                            // Set Text
                            if (tooltipModel.body) {
                              const titleLines = tooltipModel.title || [];
                              const bodyLines = tooltipModel.body.map(getBody);

                              let innerHtml = '<div class="content">';

                              bodyLines.forEach((body, idx) => {
                                innerHtml += `<ul><li>${titleLines[idx]}</li><li>${body}</li></ul>`;
                              });
                              innerHtml += '</div>';

                              const tableRoot = tooltipEl.querySelector(
                                'table'
                              );
                              tableRoot.innerHTML = innerHtml;
                            }

                            // Styles the Tooltip
                            const canvas = document.getElementById(
                              'total-cost-doughtnut'
                            );
                            const position = canvas.getBoundingClientRect();

                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.left =
                              position.left +
                              window.pageXOffset +
                              tooltipModel.caretX +
                              'px';
                            tooltipEl.style.top =
                              position.top +
                              window.pageYOffset +
                              tooltipModel.caretY +
                              'px';
                          },

                          callbacks: {
                            title: (tooltipItem, data) => {
                              return data.labels[tooltipItem[0].index];
                            },
                            label: (item, data) => {
                              return `$${
                                data.datasets[item.datasetIndex].data[
                                  item.index
                                ]
                              }M`;
                            }
                          }
                        },
                        legend: {
                          display: false
                        }
                      },
                      responsive: true,
                      title: {
                        display: false
                      },
                      animation: {
                        animateScale: true,
                        animateRotate: true
                      },
                      cutout: '80%'
                    }}
                    key={new Date().getTime()}
                    style={{ marginTop: '0' }}
                  />
                </div>
                <div
                  style={{
                    position: 'absolute',
                    fontSize: '2em',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    zIndex: 5
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                      width: '100%',
                      bottom: 15,
                      marginBottom: 6
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 'medium',
                        fontSize: '2rem',
                        top: '.5em'
                      }}
                    >
                      48%
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        fontSize: '.8rem',
                        top: '1.8em'
                      }}
                    >
                      Budget Spent
                    </div>
                  </div>
                </div>
              </div>
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </Grid.Column>
            */}
          </Grid.Row>
        </Grid>
      </div>
    </Segment>
  );
};
